<template>
  <div
    class="fixed inset-0 z-[1000] bg-slate-50 px-5 flex items-center justify-center"
    data-testid="v3-connection-error"
  >
    <div class="w-full max-w-md">
      <div class="bg-white rounded-xl shadow-sm border overflow-hidden">
        <div class="p-8 text-center space-y-4">
          <div class="mx-auto w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center">
            <svg
              class="w-7 h-7 text-amber-500"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M5 12.55a11 11 0 0 1 14.08 0" />
              <path d="M1.42 9a16 16 0 0 1 21.16 0" />
              <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
              <line x1="12" y1="20" x2="12.01" y2="20" />
            </svg>
          </div>

          <h1 class="text-xl font-bold text-gray-900">
            การเชื่อมต่อมีปัญหา
          </h1>
          <p class="text-gray-500">
            โหลดข้อมูลไม่ครบ กรุณากดปุ่มด้านล่างเพื่อโหลดใหม่
          </p>
          <p class="text-sm text-gray-400">
            รายการที่เลือกไว้ยังอยู่ ไม่ต้องเริ่มใหม่
          </p>

          <div class="pt-2">
            <button
              @click="reload"
              type="button"
              :disabled="isReloading"
              class="w-full py-3 px-4 bg-green-600 hover:bg-green-700 disabled:bg-gray-300 text-white rounded-lg font-medium transition-colors"
              data-testid="v3-connection-error-reload"
            >
              {{ isReloading ? 'กำลังโหลดใหม่...' : 'โหลดใหม่' }}
            </button>
          </div>

          <p class="text-sm text-gray-400">หรือเช็คสัญญาณอินเทอร์เน็ตแล้วลองอีกครั้ง</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// components/v3/App/ConnectionError.vue — the screen a guest gets when a chunk
// fails to load. Presentational only: the callers decide when to show it.
//
//   `app.vue`    — the failure happened while navigating; the app is alive and
//                  this covers it.
//   `error.vue`  — the failure was fatal (a direct load / refresh), so Nuxt
//                  replaced `app.vue` with the error page. Rendering it here
//                  too keeps both paths on the same screen.
//
// The cart survives: it lives in localStorage and `stepRestoreCart()` reads it
// back on the next boot — hence the reassurance in the copy.
import { ref } from 'vue'

const isReloading = ref(false)

/**
 * A plain reload. `location.reload()` may reuse the cached HTML, which is what
 * asked for the missing chunk in the first place, so the HTML is served
 * `Cache-Control: no-cache` (firebase.json) and the browser revalidates it.
 */
function reload(): void {
  isReloading.value = true
  window.location.reload()
}
</script>
